import { APIObject, APILookupValue } from "@/services/api/types";

export enum UserStatus {
  ACTIVE = 1,
  INACTIVE = 2,
  PENDING = 3,
  EXPIRED = 4
}

interface UserData extends APIObject {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  department: number;
  departmentName?: string;
  email: string | null;
  lastLoginAt: string;
  timezone: string;
  role: number;
  jobTitle: string;
  avatarUrl: string;
  groupIds: string[];
  directReports?: string[];
  managerId?: string;
  createdAt?: string;
  status?: UserStatus;
  areaOfResponsibility?: string;
}

interface MultiUsersResponse extends APIObject {
  users?: UserData[];
}

interface UserStatsData {
  companies: number;
  deals: number;
  leads: number;
}

export interface UserRole {
  id: number;
  name: string;
  department: number;
  description: string;
  type?: number;
}

export interface UserRolesResponse {
  roles: UserRole[];
}

export interface UserProvisioningResponse {
  enabled: boolean;
  managedDomains: string[];
  // Absent from servers that predate exclusions.
  excludedEmails?: string[];
}

export interface UserDepartmentsResponse {
  departments: APILookupValue[];
}

export interface UserAreaOfResponsibilityResponse {
  area_of_responsibility: APILookupValue[];
}

export interface UserTransferRequest {
  fromIds: string[];
  toIds: Record<string, string>;
}

export interface UserTransferResult {
  successfulTransfers: Record<string, number>;
  failedTransfers: Record<string, string>;
  totalTransferred: number;
}

export enum ReservedUserIds {
  UNKNOWN_USER_ID = "u-unk-nown",
  DREAMER_CONVERSATIONAL_ID = "u-dreh-conv",
  MENTOR_CONVERSATIONAL_ID = "u-dreh-ment",
  SYSTEM_CONVERSATIONAL_ID = "u-dreh-syst",
  ALERTS_CONVERSATIONAL_ID = "u-dreh-alrt",
  NOTIFICATIONS_CONVERSATIONAL_ID = "u-dreh-ntfy"
}

export const unknownUser: UserData = {
  id: ReservedUserIds.UNKNOWN_USER_ID,
  firstName: "Unknown",
  lastName: "User",
  displayName: "Unknown",
  department: 1,
  email: "",
  lastLoginAt: "",
  timezone: "",
  role: 1,
  jobTitle: "",
  avatarUrl: "",
  groupIds: []
};

export type { UserData, MultiUsersResponse, UserStatsData };
